import { render, staticRenderFns } from "./TournamentDetails.vue?vue&type=template&id=4872c8d8&scoped=true"
import script from "./TournamentDetails.vue?vue&type=script&lang=js"
export * from "./TournamentDetails.vue?vue&type=script&lang=js"
import style0 from "./TournamentDetails.vue?vue&type=style&index=0&id=4872c8d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4872c8d8",
  null
  
)

export default component.exports